import { render } from "./ConhecimentoView.vue?vue&type=template&id=7264d5a6&scoped=true"
import script from "./ConhecimentoView.vue?vue&type=script&lang=js"
export * from "./ConhecimentoView.vue?vue&type=script&lang=js"

import "./ConhecimentoView.vue?vue&type=style&index=0&id=7264d5a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7264d5a6"]])

export default __exports__